var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',{attrs:{"size":"sm","state":_vm.state,"browse-text":_vm.$gettext('browse'),"accept":_vm.accept,"drop-placeholder":_vm.$gettext('drop file here')},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }